/**
 * Sample Product Quantity Limit
 * Restricts specific products to a maximum quantity of 1 in the cart.
 * Works by intercepting all fetch calls to /cart/add and /cart/change endpoints.
 */
(function () {
  'use strict';

  // ─── Configuration ───────────────────────────────────────────
  const SAMPLE_PRODUCT_IDS = [8533270134942, 8533304410270];
  const SAMPLE_PRODUCT_LIMIT = 1;
  const ERROR_MESSAGE = 'You cannot add more sample products. The limit is 1 product';

  // ─── Helpers ─────────────────────────────────────────────────
  function isSampleProduct(productId) {
    return SAMPLE_PRODUCT_IDS.includes(Number(productId));
  }

  function showErrorPopup(message) {
    // Try EasyDialogBox first (theme's dialog system)
    if (typeof EasyDialogBox !== 'undefined') {
      try {
        var dlg = EasyDialogBox.create(
          'sample_limit_error',
          'dlg dlg-disable-footer dlg-disable-drag dlg-disable-heading',
          '',
          '<div style="padding:20px;text-align:center;">' +
            '<svg width="40" height="40" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-bottom:10px;">' +
              '<path d="M8.4375 17.4375C6.76872 17.4375 5.13742 16.9427 3.74988 16.0155C2.36234 15.0884 1.28088 13.7706 0.64227 12.2289C0.00365592 10.6871-0.163435 8.99064 0.162128 7.35393C0.487691 5.71721 1.29128 4.2138 2.47129 3.03379C3.6513 1.85378 5.15471 1.05019 6.79143 0.724628C8.42814 0.399065 10.1246 0.566156 11.6664 1.20477C13.2081 1.84338 14.5259 2.92484 15.453 4.31238C16.3802 5.69992 16.875 7.33122 16.875 9C16.875 11.2378 15.9861 13.3839 14.4037 14.9662C12.8214 16.5486 10.6753 17.4375 8.4375 17.4375Z" fill="#904141"/>' +
              '<path d="M4.93805 8.12805C5.42268 8.12805 5.81555 7.73518 5.81555 7.25055C5.81555 6.76592 5.42268 6.37305 4.93805 6.37305C4.45342 6.37305 4.06055 6.76592 4.06055 7.25055C4.06055 7.73518 4.45342 8.12805 4.93805 8.12805Z" fill="white"/>' +
              '<path d="M11.9361 8.12805C12.4207 8.12805 12.8136 7.73518 12.8136 7.25055C12.8136 6.76592 12.4207 6.37305 11.9361 6.37305C11.4515 6.37305 11.0586 6.76592 11.0586 7.25055C11.0586 7.73518 11.4515 8.12805 11.9361 8.12805Z" fill="white"/>' +
              '<path d="M11.5317 12.6227C11.4577 12.6231 11.3843 12.6089 11.3157 12.5809C11.2472 12.5529 11.1849 12.5117 11.1323 12.4595C10.4173 11.7458 9.44826 11.3449 8.43795 11.3449C7.42763 11.3449 6.4586 11.7458 5.74357 12.4595C5.69128 12.5123 5.62907 12.5541 5.56052 12.5827C5.49197 12.6112 5.41845 12.6259 5.3442 12.6259C5.26994 12.6259 5.19642 12.6112 5.12787 12.5827C5.05933 12.5541 4.99711 12.5123 4.94482 12.4595C4.84005 12.3541 4.78125 12.2116 4.78125 12.063C4.78125 11.9144 4.84005 11.7718 4.94482 11.6664C5.87255 10.7424 7.12858 10.2236 8.43795 10.2236C9.74731 10.2236 11.0033 10.7424 11.9311 11.6664C12.0358 11.7718 12.0946 11.9144 12.0946 12.063C12.0946 12.2116 12.0358 12.3541 11.9311 12.4595C11.8785 12.5117 11.8162 12.5529 11.7476 12.5809C11.6791 12.6089 11.6057 12.6231 11.5317 12.6227Z" fill="white"/>' +
            '</svg>' +
            '<p style="margin:0;font-size:15px;color:#904141;font-weight:600;">' + message + '</p>' +
          '</div>'
        );
        if (dlg) {
          dlg.onClose = dlg.destroy;
          dlg.show();
          return;
        }
      } catch (e) {
        // fall through to alert
      }
    }
    alert(message);
  }

  async function getCart() {
    var res = await fetch('/cart.json', { method: 'GET', headers: { 'Accept': 'application/json' } });
    return res.json();
  }

  function getExistingQuantity(cart, productId) {
    var item = cart.items.find(function (i) { return Number(i.product_id) === Number(productId); });
    return item ? item.quantity : 0;
  }

  function removeLoadingStates() {
    document.querySelectorAll('.btn-loading').forEach(function (el) {
      el.classList.remove('btn-loading');
    });
    document.querySelectorAll('[type="submit"][disabled]').forEach(function (el) {
      el.removeAttribute('disabled');
      var span = el.querySelector('span');
      if (span) span.classList.remove('hidden');
    });
    document.querySelectorAll('.loader-icon').forEach(function (el) {
      el.remove();
    });
  }

  // ─── Fetch Interceptor ──────────────────────────────────────
  var originalFetch = window.fetch;

  window.fetch = async function (url, options) {
    var urlStr = typeof url === 'string' ? url : (url && url.url ? url.url : '');

    // ── Intercept /cart/add ──────────────────────────────────
    if (urlStr.indexOf('/cart/add') !== -1 && options && options.method && options.method.toUpperCase() === 'POST') {
      try {
        var variantId = null;
        var quantityToAdd = 1;
        var body = options.body;

        // Parse body to get variant id and quantity
        if (body instanceof FormData) {
          // FormData – could be single item or items[]
          var idVal = body.get('id');
          var qtyVal = body.get('quantity');
          if (idVal) {
            variantId = Number(idVal);
            quantityToAdd = qtyVal ? Number(qtyVal) : 1;
          }
          // items[] format (product groups) – check each
          var entries = Array.from(body.entries());
          var itemIds = entries.filter(function (e) { return e[0].indexOf('[id]') !== -1; });
          if (itemIds.length > 0) {
            var cart = await getCart();
            for (var idx = 0; idx < itemIds.length; idx++) {
              var entryKey = itemIds[idx][0];
              var entryVariantId = Number(itemIds[idx][1]);
              // Find matching quantity key
              var qtyKey = entryKey.replace('[id]', '[quantity]');
              var qtyEntry = entries.find(function (e) { return e[0] === qtyKey; });
              var qty = qtyEntry ? Number(qtyEntry[1]) : 1;
              if (qty <= 0) continue;

              // We need to check if this variant belongs to a sample product
              // Check cart items for matching variant to get product_id
              var cartItem = cart.items.find(function (i) { return Number(i.variant_id) === entryVariantId; });
              if (cartItem && isSampleProduct(cartItem.product_id)) {
                var existingQty = getExistingQuantity(cart, cartItem.product_id);
                if (existingQty + qty > SAMPLE_PRODUCT_LIMIT) {
                  removeLoadingStates();
                  showErrorPopup(ERROR_MESSAGE);
                  return new Response(JSON.stringify({ errors: ERROR_MESSAGE }), { status: 422, headers: { 'Content-Type': 'application/json' } });
                }
              }
            }
            // For items[] format, continue with normal fetch if no limit hit
            return originalFetch.apply(this, arguments);
          }
        } else if (typeof body === 'string') {
          try {
            var parsed = JSON.parse(body);
            variantId = parsed.id ? Number(parsed.id) : null;
            quantityToAdd = parsed.quantity ? Number(parsed.quantity) : 1;
          } catch (e) { /* not JSON */ }
        }

        if (variantId && quantityToAdd > 0) {
          var cart = await getCart();

          // Find product_id from variant_id in cart items
          var productId = null;
          var cartMatch = cart.items.find(function (i) { return Number(i.variant_id) === variantId; });
          if (cartMatch) {
            productId = cartMatch.product_id;
          }

          // If product already in cart, check limit
          if (productId && isSampleProduct(productId)) {
            var existingQty = getExistingQuantity(cart, productId);
            if (existingQty + quantityToAdd > SAMPLE_PRODUCT_LIMIT) {
              removeLoadingStates();
              showErrorPopup(ERROR_MESSAGE);
              return new Response(JSON.stringify({ errors: ERROR_MESSAGE }), { status: 422, headers: { 'Content-Type': 'application/json' } });
            }
          }

          // If not in cart yet, we need to check after the add succeeds
          // We do this by proceeding with the add, then checking the result
          if (!productId) {
            var result = await originalFetch.apply(this, arguments);
            var cloned = result.clone();
            try {
              var responseData = await cloned.json();
              if (responseData && responseData.product_id && isSampleProduct(responseData.product_id)) {
                // Product was just added – if quantity > limit, remove it
                if (responseData.quantity > SAMPLE_PRODUCT_LIMIT) {
                  // Revert by changing quantity to limit
                  await originalFetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ id: responseData.key, quantity: SAMPLE_PRODUCT_LIMIT })
                  });
                  removeLoadingStates();
                  showErrorPopup(ERROR_MESSAGE);
                  return new Response(JSON.stringify({ errors: ERROR_MESSAGE }), { status: 422, headers: { 'Content-Type': 'application/json' } });
                }
              }
            } catch (e) { /* response might not be JSON */ }
            return result;
          }
        }
      } catch (e) {
        console.error('Sample product limit check failed:', e);
        // On error, allow the request through
      }
    }

    // ── Intercept /cart/change ────────────────────────────────
    if (urlStr.indexOf('/cart/change') !== -1 && options && options.method && options.method.toUpperCase() === 'POST') {
      try {
        var body = options.body;
        var newQuantity = null;
        var lineKey = null;
        var lineIndex = null;

        if (typeof body === 'string') {
          try {
            var parsed = JSON.parse(body);
            newQuantity = parsed.quantity !== undefined ? Number(parsed.quantity) : null;
            lineKey = parsed.id || null;
            lineIndex = parsed.line || null;
          } catch (e) { /* not JSON */ }
        }

        if (newQuantity !== null && newQuantity > SAMPLE_PRODUCT_LIMIT) {
          var cart = await getCart();
          var cartItem = null;

          if (lineIndex) {
            cartItem = cart.items[lineIndex - 1] || null;
          }
          if (!cartItem && lineKey) {
            cartItem = cart.items.find(function (i) {
              return i.key === lineKey || String(i.id) === String(lineKey) || String(i.variant_id) === String(lineKey);
            });
          }

          if (cartItem && isSampleProduct(cartItem.product_id)) {
            removeLoadingStates();
            showErrorPopup(ERROR_MESSAGE);
            // Reset the quantity input in DOM
            document.querySelectorAll('input[data-id="' + (lineKey || '') + '"]').forEach(function (el) {
              el.value = SAMPLE_PRODUCT_LIMIT;
            });
            document.querySelectorAll('input[data-key="' + (lineKey || '') + '"]').forEach(function (el) {
              el.value = SAMPLE_PRODUCT_LIMIT;
            });
            if (lineIndex) {
              var qtyEl = document.getElementById('Quantity-' + lineIndex);
              if (qtyEl) qtyEl.value = SAMPLE_PRODUCT_LIMIT;
            }
            return new Response(JSON.stringify({ errors: ERROR_MESSAGE }), { status: 422, headers: { 'Content-Type': 'application/json' } });
          }
        }
      } catch (e) {
        console.error('Sample product limit check failed:', e);
      }
    }

    // ── Pass through all other requests ──────────────────────
    return originalFetch.apply(this, arguments);
  };

  // ─── Quantity Input Blocker ─────────────────────────────────
  // Prevent the plus button from incrementing past the limit for sample products
  document.addEventListener('click', async function (event) {
    var button = event.target.closest('button[name="plus"], button.btn-add');
    if (!button) return;

    var quantityInput = button.closest('quantity-input');
    if (!quantityInput) return;

    var input = quantityInput.querySelector('input[type="number"]');
    if (!input) return;

    var currentValue = Number(input.value) || 0;
    if (currentValue < SAMPLE_PRODUCT_LIMIT) return; // Will be fine after increment

    // Check if this is a cart item (has data-id or data-key)
    var itemKey = input.dataset.id || input.dataset.key;
    if (!itemKey) return; // Not in cart context

    try {
      var cart = await getCart();
      var cartItem = cart.items.find(function (i) {
        return i.key === itemKey || String(i.id) === String(itemKey) || String(i.variant_id) === String(itemKey);
      });

      if (cartItem && isSampleProduct(cartItem.product_id) && currentValue >= SAMPLE_PRODUCT_LIMIT) {
        event.preventDefault();
        event.stopImmediatePropagation();
        showErrorPopup(ERROR_MESSAGE);
      }
    } catch (e) {
      console.error('Sample product limit check failed:', e);
    }
  }, true); // Use capture phase to run before other handlers
})();
